import { HttpErrorResponse } from '@angular/common/http'
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { ApplicationInsightsService } from '../services/insights/application-insights.service'

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    #isHandlingError = false

    constructor(
        private injector: Injector,
        private ngZone: NgZone
    ) {}

    handleError(error: unknown): void {
        // Prevent re-entrancy loop
        if (this.#isHandlingError) {
            return
        }

        // Skip rxResource errors - these are already handled by the resource's error state
        // and showing a toastr would cause a change detection loop
        if (error instanceof Error && error.message.includes('error state')) {
            console.warn('rxResource error (handled by resource):', error.cause)
            return
        }

        this.#isHandlingError = true

        try {
            const toastr = this.injector.get(ToastrService)
            const applicationInsightsService = this.injector.get(ApplicationInsightsService)

            applicationInsightsService.trackException(error instanceof Error ? error : new Error('Unknown error'), {
                errorType: error instanceof Error ? error.name : 'UnknownError',
                errorMessage: error instanceof Error ? error.message : 'Unknown error',
            })

            if (error instanceof Error) {
                console.error('An error occurred:', error.message, error.stack)

                this.ngZone.run(() => {
                    toastr.error(error.message, 'Error', { timeOut: 3000 })
                })
            } else if (error instanceof HttpErrorResponse) {
                // already handled by globalErrorHandlerInterceptor, but log it here for debugging
                console.error('HTTP error occurred:', error.message, error.status, error.url)
            } else {
                console.error('An unknown error occurred:', error)
                this.ngZone.run(() => {
                    toastr.error('An unknown error occurred', 'Error', { timeOut: 3000 })
                })
            }
        } catch (handlerError) {
            console.error('Error in error handler:', handlerError)
        } finally {
            this.#isHandlingError = false
        }
    }
}
